import axios from '@/plugins/axios'

const getGenres = async ({ countBookType = null, countBookAmount = null }) => {
  try {
    const params = {}
    if (countBookType) params.count_book_type = countBookType
    if (countBookAmount) params.count_book_amount = countBookAmount
    const response = await axios.get('genres', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getGenres
}
